if (!customElements.get('full-image-slider')) {
  class FullImageSlider extends HTMLElement {
    static settings = {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: true,
      loop: true,
    };
    slider = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.slider = new Swiper(
        this.querySelector('.swiper'),
        FullImageSlider.settings,
      );
    }
  }
  customElements.define('full-image-slider', FullImageSlider);
}
